var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DefaultLayout,{attrs:{"userMenu":true}},[_c('div',{staticClass:"d-flex flex-column gap-5"},[_c(_setup.AuthTable),_c(_setup.PermissionTable)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }